import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgPlusClear = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 14 14",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "nonzero",
		d: "M14 8H8v6H6V8H0V6h6V0h2v6h6z"
	})
});
export default SvgPlusClear;
